export interface Country {
  id: number
  name: string
  path?: string
  shopId?: number
  languageCode: string
  countryCode?: string
  languages: Language[]
  icon?: string
}

export interface Language {
  label: string
  url: string
  icon?: string
  path?: string
  shopId?: number
}

export const countries: Country[] = [
  {
    id: 1,
    name: 'USA',
    languageCode: 'en-US',
    countryCode: 'US',
    languages: [
      {
        label: 'English',
        url: 'https://www.snipesusa.com',
        icon: 'IconFlagsUs',
      },
    ],
    icon: 'IconFlagsUs',
  },
  {
    id: 2,
    name: 'Germany',
    languageCode: 'de-DE',
    countryCode: 'DE',
    shopId: 1048,
    path: 'en-de',
    languages: [
      {
        label: 'Deutsch',
        url: 'https://www.snipes.com/de-de',
        icon: 'IconFlagsDe',
        path: 'de-de',
        shopId: 1048,
      },
    ],
    icon: 'IconFlagsDe',
  },
  {
    id: 3,
    name: 'Belgium',
    path: 'en-be',
    shopId: 1061,
    languageCode: 'fr-BE',
    countryCode: 'BE',
    languages: [
      {
        label: 'Français',
        url: 'https://www.snipes.com/fr-be/',
        icon: 'IconFlagsFr',
        path: 'fr-be',
        shopId: 1061,
      },
      {
        label: 'Nederlands',
        url: 'https://www.snipes.com/nl-be/',
        icon: 'IconFlagsNl',
        path: 'nl-be',
        shopId: 1062,
      },
    ],
    icon: 'IconFlagsBe',
  },
  {
    id: 4,
    name: 'Spain',
    path: 'en-es',
    languageCode: 'es-ES',
    countryCode: 'ES',
    shopId: 1036,
    languages: [
      {
        label: 'Español',
        url: 'https://www.snipes.com/es-es/',
        icon: 'IconFlagsEs',
        path: 'es-es',
        shopId: 1036,
      },
    ],
    icon: 'IconFlagsEs',
  },
  {
    id: 5,
    name: 'France',
    path: 'en-fr',
    shopId: 1042,
    languageCode: 'fr-FR',
    countryCode: 'FR',
    languages: [
      {
        label: 'Français',
        url: 'https://www.snipes.com/fr-fr/',
        icon: 'IconFlagsFr',
        path: 'fr-fr',
        shopId: 1042,
      },
    ],
    icon: 'IconFlagsFr',
  },
  {
    id: 6,
    name: 'Hrvatski',
    path: 'en-hr',
    shopId: 1001,
    languageCode: 'hr-HR',
    countryCode: 'HR',
    languages: [
      {
        label: 'Hrvatski',
        url: 'https://www.snipes.com/hr-hr/',
        icon: 'IconFlagsHr',
        path: 'hr-hr',
        shopId: 1001,
      },
    ],
    icon: 'IconFlagsHr',
  },
  {
    id: 7,
    name: 'Italy',
    path: 'en-it',
    shopId: 1039,
    languageCode: 'it-IT',
    countryCode: 'IT',
    languages: [
      {
        label: 'Italiano',
        url: 'https://www.snipes.com/it-it/',
        icon: 'IconFlagsIt',
        path: 'it-it',
        shopId: 1039,
      },
    ],
    icon: 'IconFlagsIt',
  },
  {
    id: 8,
    name: 'Netherlands',
    path: 'en-nl',
    shopId: 1054,
    languageCode: 'nl-NL',
    countryCode: 'NL',
    languages: [
      {
        label: 'Nederlands',
        url: 'https://www.snipes.com/nl-nl/',
        icon: 'IconFlagsNl',
        path: 'nl-nl',
        shopId: 1054,
      },
    ],
    icon: 'IconFlagsNl',
  },
  {
    id: 9,
    name: 'Austria',
    path: 'en-at',
    shopId: 1051,
    languageCode: 'de-AT',
    countryCode: 'AT',
    languages: [
      {
        label: 'Deutsch (Austria)',
        url: 'https://www.snipes.com/de-at/',
        icon: 'IconFlagsAt',
        path: 'de-at',
        shopId: 1051,
      },
    ],
    icon: 'IconFlagsAt',
  },
  {
    id: 10,
    name: 'Poland',
    path: 'en-pl',
    shopId: 1045,
    languageCode: 'pl-PL',
    countryCode: 'PL',
    languages: [
      {
        label: 'Polski',
        url: 'https://www.snipes.com/pl-pl/',
        icon: 'IconFlagsPl',
        path: 'pl-pl',
        shopId: 1045,
      },
    ],
    icon: 'IconFlagsPl',
  },
  {
    id: 11,
    name: 'Portugal',
    path: 'en-pt',
    shopId: 1033,
    languageCode: 'pt-PT',
    countryCode: 'PT',
    languages: [
      {
        label: 'Português',
        url: 'https://www.snipes.com/pt-pt/',
        icon: 'IconFlagsPt',
        path: 'pt-pt',
        shopId: 1033,
      },
    ],
    icon: 'IconFlagsPt',
  },
  {
    id: 12,
    name: 'Switzerland',
    path: 'en-ch',
    shopId: 1057,
    languageCode: 'de-CH',
    countryCode: 'CH',
    languages: [
      {
        label: 'Deutsch',
        url: 'https://www.snipes.com/de-ch/',
        icon: 'IconFlagsDe',
        path: 'de-ch',
        shopId: 1057,
      },
      {
        label: 'Français',
        url: 'https://www.snipes.com/fr-ch/',
        icon: 'IconFlagsFr',
        path: 'fr-ch',
        shopId: 1058,
      },
    ],
    icon: 'IconFlagsCh',
  },
]
